const toCellKey = (entityId: string, slotIndex: number): string => `${entityId}:${slotIndex}`

const fromCellKey = (key: string): { entityId: string; slotIndex: number } => {
  const [entityId = '', slotIndex = '0'] = key.split(':')
  return { entityId, slotIndex: Number(slotIndex) }
}

const getRowCellCoords = (
  rowId: string,
  slotCount: number
): Array<{ entityId: string; slotIndex: number }> =>
  Array.from({ length: slotCount }, (_, index) => ({
    entityId: rowId,
    slotIndex: index,
  }))

const getColumnCellCoords = <T extends { entity: { id: string } }>(
  columnIndex: number,
  rows: T[]
): Array<{ entityId: string; slotIndex: number }> =>
  rows.map((row) => ({ entityId: row.entity.id, slotIndex: columnIndex }))

export { toCellKey, fromCellKey, getRowCellCoords, getColumnCellCoords }
